import {
  getUiState,
  UiStateKey,
  UiStateScope,
  updateUiState,
} from '../../lib/commons/uiStates'
import { useState, useCallback, useEffect } from 'react'

export const usePageState = <S>(
  functionUuid: string,
  defaultState: S,
  storedStateAdaptor: (storedState: any) => S = s => s,
  // プロジェクト単位など、同じ画面でも保存先を分けたい場合に指定する
  keySuffix?: string
): S & { updatePageState: (updated: Partial<S>) => void } => {
  const stateKey = keySuffix
    ? `${UiStateKey.PageState}_${keySuffix}`
    : UiStateKey.PageState
  const [pageState, setPageState] = useState<S>(defaultState)
  const updatePageState = useCallback(
    (updated: Partial<S>) => {
      setPageState(prev => {
        const newPageState = {
          ...prev,
          ...updated,
        }
        updateUiState(newPageState, functionUuid, stateKey)
        return newPageState
      })
    },
    [functionUuid, stateKey]
  )

  useEffect(() => {
    const fetchAndSetPageState = async () => {
      const pageState = await getUiState(
        functionUuid,
        stateKey,
        UiStateScope.User
      )
      if (!pageState) return
      setPageState({ ...defaultState, ...storedStateAdaptor(pageState) })
    }
    fetchAndSetPageState()
  }, [functionUuid, stateKey])

  return { ...pageState, updatePageState }
}
